<ul aria-label={title}>
  <h2>{title}</h2>
  {#each links as link}
    <li>
      <a href="{link.href}" class={colorClassNames.primary} {...normaliseDataAttributes(link.dataAttributes)} {...attributes}>{link.title}</a>
    </li>
  {/each}
</ul>

<style lang="less">
  @import (reference) '../../../less/variables';

  ul {
    padding: 0 @masthead-gutter-width;
    margin: 0;

    @media (min-width: @breakpoint-mobile) {
      flex: 1 0 0%;
    }
  }

  h2 {
    color: @masthead-gray-50;
    font-size: @masthead-font-size-small;
    font-weight: @masthead-font-weight-black;
    line-height: 1.4;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin: 50px 0 22px;

    @media (min-width: @breakpoint-tablet) {
      margin: 20px 0;
    }
  }

  li {
    margin: 0;
    list-style: none;
  }

  a {
    display: inline-block;
    font-size: @masthead-font-size-medium;
    font-weight: @masthead-font-weight-normal;
    line-height: 1.5;
    text-decoration: none;
    padding: 3px 0 @masthead-gutter-width 0;

    &:hover,
    &:focus {
      color: currentColor;
    }
  }
</style>

<script>
  import { normaliseDataAttributes } from '../../../lib/normaliseDataAttributes';

  export let title;
  export let links;
  export let colorClassNames;
  export let external = false;

  $: attributes = external
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};
</script>
